import mobileSortTemplate from './mobile-sort.html';
import { TableController } from './table-component';

class MobileSortController extends TableController {
  $onInit() {
    if (this.defaultSortColumn && this.defaultSortDirection) {
      this.sortBy = `${this.defaultSortColumn}-${this.defaultSortDirection}`;
    }

    this.fiteredHeaders = this.headers
      .filter((header) => (header ? header.sortable : false))
      .reduce(
        (prev, current) =>
          prev.concat([
            {
              value: `${current.field}-asc`,
              column: current.field,
              label: `${current.text} (ascending)`,
              ascending: true,
            },
            {
              value: `${current.field}-desc`,
              column: current.field,
              label: `${current.text} (descending) `,
              ascending: false,
            },
          ]),
        []
      );
  }
}

export default class MobileSortComponent {
  constructor() {
    this.bindings = {
      headers: '=',
      onSortHandler: '&',
      defaultSortColumn: '@?',
      defaultSortDirection: '@?',
    };
    this.template = mobileSortTemplate;
    this.controller = MobileSortController;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/grid/mobile-sort-component.js